import React from "react";
import ReactLoading from "react-loading";

export default function LoadPage() {
  return (
    <div className="justify-center pt-40 m-auto">
      <ReactLoading
        className="m-auto"
        type={"spinningBubbles"}
        color={"#3059a9"}
        height={150}
        width={150}
      />
    </div>
  );
}
